<template>
  <div class="diy-alerts">
    <div class="diy-alerts__wrapper">
      <template v-if="alerts.length">
        <AlertsItem
          v-for="alert in alerts"
          :key="alert.id"
          :alert="alert"
          @toggle-status="changeAlertStatus"
        />
      </template>
      <div v-else-if="!alerts.length" class="diy-alerts__no-notifications">
        <AppImage :src="noNotificationImage" />
        {{ $t('topbar.menu.labels.no_alerts', { days: 30 }) }}
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import NoNotificationBell from 'Images/components/no-notifications-bell.png'
// Components
import AppImage from 'Ui/AppImage'
import AlertsItem from './components/AlertsItem'

export default {
  name: 'Alerts',

  components: {
    AppImage,
    AlertsItem,
  },

  data() {
    return {
      noNotificationImage: NoNotificationBell,
    }
  },

  methods: {
    async changeAlertStatus(alert) {
      const updateInfo = {
        id: alert.id,
        status: {
          is_active: !alert.is_active,
        },
      }

      this.$store.dispatch('alerts/update', updateInfo)
      EventBus.$emit('reload-user-content')
    },
  },

  computed: {
    alerts() {
      return this.$store.state.alerts.userAlerts || []
    },
  },
}
</script>

<style scoped>
.diy-alerts__wrapper {
  display: grid;
  gap: 0.625rem;
  padding: 0 0.3125rem;
  margin-top: 1px;
  max-height: 500px;
  background-color: rgba(0, 0, 0, 0.01);
  overflow-x: hidden;
}

.diy-alerts__no-notifications {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.875rem;
  color: var(--c-secondary-700);
  text-align: center;
  padding: 0.625rem 0.625rem 0.3125rem;
}

.diy-alerts__no-notifications .app-image {
  margin: 0 auto;
  max-width: 120px;
  height: auto;
  min-height: 81px;
  overflow: hidden;
}
</style>
